import styled from 'styled-components';
import React, {useState,useEffect } from 'react';
import { Colors as LightColors , DarkColors } from '../../style/colors';
import  { Schema } from 'joi';

import { SelectField, SelectFieldOptions } from './SelectField';
import {TextField, TextFieldOptions,TextFieldType } from './TextField';
import { PhoneField,PhoneFieldOptions } from './PhoneField';
import { MultiSelectField,MultiSelectFieldOptions } from './multiSelect';
import { CheckboxField,CheckBoxFieldOptions } from './CheckBoxField';
import { FilterSelectField } from './filterSelect';
import { RangeField,RangeFieldOptions } from './Range';
import { DateRangeField, DateRangeFieldOptions } from './DateRange';
import { DateTimeFieldOptions, DateTimePicker } from './DatePicker';
import { useDictionary } from '../../contexts/dictionary';
import { UploadField } from './UploadField';


export {TextFieldType}

export enum FieldType{
  text=1,
  checkBox=2,
  multiSelect=3,
  select=4,
  phone=5,
  filterSelect=6,
  range=7,
  dateRange=8,
  dateTime=9,
  upload=10,
}


export interface FieldConfig {
  type:FieldType;
  name:string;
  label:string;
  hide?:boolean
  readonly?:boolean
  defaultValue?:any;
  joiSchema:Schema;
  typeOptions?: SelectFieldOptions | TextFieldOptions | PhoneFieldOptions | MultiSelectFieldOptions | CheckBoxFieldOptions | RangeFieldOptions | DateRangeFieldOptions | DateTimeFieldOptions
}


export interface FieldTypeProps {
  fieldConfig:FieldConfig
  onBlur:()=>void
  onFocuse:()=>void
  onFieldChange:(name:string,value:any)=>void;
  colorState:ColorState
  isActive:boolean
  theme?: 'light' | 'dark';
}

export enum ColorState {
  normal="normal",
  error="error",
  success="success"

} 

export interface FieldProps {
  fieldConfig:FieldConfig
  serverRes?: ApiResponse | null
  onChange:(name:string,value:any,valid:boolean)=>void;
  theme?:'light'|'dark';
}


export const Field= ({fieldConfig,onChange,serverRes,theme='light'}:FieldProps)  => {
  const {translate} = useDictionary()
  const Colors = theme==='light'?LightColors:DarkColors
  
  const {type,name,defaultValue,joiSchema} = fieldConfig
  const [errorMessage,setErrorMessage] = useState<string | null>(null)
  const [isActive,setIsActive] = useState<boolean>(false)
  const [value,setValue] = useState<any>(defaultValue)
  const [colorState,setColorState] = useState<ColorState>(ColorState.normal)
  const [visible,setVisible] = useState<boolean>(!fieldConfig.hide)



  const getFieldComponent = ()=>{
    switch (type){
      case FieldType.select:
        return (<SelectField fieldConfig={fieldConfig} onBlur={onBlur} onFocuse={onFocus} onFieldChange={onFieldChange} colorState={colorState} isActive={isActive}/>)
      case FieldType.filterSelect:
          return (<FilterSelectField fieldConfig={fieldConfig} onBlur={onBlur} onFocuse={onFocus} onFieldChange={onFieldChange} colorState={colorState} isActive={isActive}/>)
      case FieldType.text:
        return (<TextField fieldConfig={fieldConfig} onBlur={onBlur} onFocuse={onFocus} onFieldChange={onFieldChange} colorState={colorState} isActive={isActive} theme={theme}/>)
      case FieldType.phone:
        return (<PhoneField fieldConfig={fieldConfig} onBlur={onBlur} onFocuse={onFocus} onFieldChange={onFieldChange} colorState={colorState} isActive={isActive}/>)
      case FieldType.multiSelect:
        return (<MultiSelectField fieldConfig={fieldConfig} onBlur={onBlur} onFocuse={onFocus} onFieldChange={onFieldChange} colorState={colorState} isActive={isActive}/>)
      case FieldType.checkBox:
        return (<CheckboxField fieldConfig={fieldConfig}   onFieldChange={onFieldChange} colorState={colorState} />)
      case FieldType.range:
        return (<RangeField fieldConfig={fieldConfig} onBlur={onBlur} onFocuse={onFocus} onFieldChange={onFieldChange} colorState={colorState} isActive={isActive}/>)
      case FieldType.dateRange:
        return (<DateRangeField fieldConfig={fieldConfig} onBlur={onBlur} onFocuse={onFocus} onFieldChange={onFieldChange} colorState={colorState} isActive={isActive}/>)
      case FieldType.dateTime:
        return (<DateTimePicker fieldConfig={fieldConfig} onBlur={onBlur} onFocuse={onFocus} onFieldChange={onFieldChange} colorState={colorState} isActive={isActive}/>)
      case FieldType.upload:
        return (<UploadField fieldConfig={fieldConfig}   onFieldChange={onFieldChange} />)
    }
  }

 


  const onBlur = ()=>{
    const validation = validate(value)
    const colorState = validation.isValid ? ColorState.success : ColorState.error
    setColorState(colorState)
    setIsActive(false)

  }

  const onFocus = ()=>{
    setColorState(ColorState.normal)
    setIsActive(true)

  }

  const onFieldChange = (propName:string,value:any)=>{
    let validation = {isValid:true}
    if(propName===name){
      validation = validate(value)
      setValue(value);
      setColorState(ColorState.normal)
    }
  
    onChange(propName,value,validation.isValid)
   
  }

  const validate = (value: any) => {
    const res = joiSchema.validate(value);
    
    const validation:{isValid:boolean,error:string | null} = {
      isValid:true,
      error:null 
    }

    if(res.error){
      console.log("*"+res.error.message+"*")
      validation.isValid=false
      validation.error=res.error.message.replace(`"value" is `,``).replace(`"value"`,``)
      console.log(translate(validation.error),"-validation error-",translate("boy"),"*"+validation.error+"*")
      setErrorMessage(translate(validation.error))
    } else {
      setErrorMessage(null)
    }
    return validation
    
  };

  useEffect(() => {
    
    if(defaultValue && type!==FieldType.upload){
      onFieldChange(name,defaultValue)
    }

  }, [defaultValue]);

  useEffect(() => {
    
    setVisible(!fieldConfig.hide)

  }, [fieldConfig.hide]);
  
  
  

  React.useEffect(() => {

    if(serverRes?.fieldName===name && serverRes.succeeded===false){
      if(serverRes.errorDescription){
        setErrorMessage(serverRes.errorDescription)
        setColorState(ColorState.error)
      }
        
    }
    
  }, [serverRes]);



  

  return (
    <Form>
      {
        visible && getFieldComponent()
      }

    
  
      {visible &&  colorState===ColorState.error && 
        <ErrorMessage $Colors={Colors}>{errorMessage}</ErrorMessage>
        
      }
    </Form>
  );
}



const Form = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width:100%;
  /* margin-right: 25px; */
`;


const ErrorMessage = styled.p<{$Colors:any}>`
  color: ${props=>props.$Colors.error};
  font-size: 14px;
  margin-top: -5px;
  margin-bottom: 2px;
`;





